/*
 * parseFilenameAsTitle — example input/output pairs
 *
 *  "bohemian_rhapsody.pdf"              → "Bohemian Rhapsody"
 *  "hotel-california.pdf"               → "Hotel California"
 *  "DONT_STOP_ME_NOW.pdf"               → "Dont Stop Me Now"
 *  "sweet_home_alabama_feat_DJ_mix.pdf" → "Sweet Home Alabama Feat DJ Mix"
 *  "MrBrightSide.PDF"                   → "Mrbrightside"  (no separators → single word)
 *  "back_in--black.pdf"                 → "Back In Black"
 */

/**
 * Converts a PDF filename into a human-readable title.
 *
 * @param {string} filename
 * @returns {string}
 */
export default function parseFilenameAsTitle(filename) {
  const withoutExt = filename.replace(/\.pdf$/i, "");

  const spaced = withoutExt.replace(/[_-]+/g, " ");

  const collapsed = spaced.replace(/\s+/g, " ").trim();

  const titleCased = collapsed
    .split(" ")
    .map((word) => {
      // Keep short all-caps words intact (e.g. "DJ", "BPM", "feat" is lowercase so won't match)
      if (word.length <= 3 && word === word.toUpperCase() && /[A-Z]/.test(word)) {
        return word;
      }
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(" ");

  return titleCased;
}
